import type { SurfaceScope } from '@/lib/monetization';

/**
 * Human-readable label for a gift / offer / lot scope. The api only returns
 * ids (not names) on these surfaces, so we keep it to the scope *kind* — enough
 * for the player to know whether a token is spend-anywhere or restricted.
 */
export function scopeLabel(scope: SurfaceScope | undefined | null): string {
  switch (scope?.type) {
    case 'EVENT':
      return 'this event';
    case 'SUB_CATEGORY':
      return 'this market group';
    case 'CATEGORY':
      return 'this category';
    case 'ALL':
    default:
      return 'any market';
  }
}
